import { observer } from 'mobx-react';
import { FormLayout } from '../../layout/formLayout';
import { Section } from '../../layout/section';
import { FormBuilderStore } from './formBuilderStore';
import { FormBuilderContext } from 'controls/react/form/formBuilderNew/formBuilderContext';
import { AntAlert } from 'controls/react/ant/antAlert';
import b_ from 'b_';
import { ToolbarItemPosition, Toolbar } from 'controls/react/layout/toolbar';
import { AntSwitch } from 'controls/react/ant/antSwitch';
import { AntFlex } from 'controls/react/ant/antFlex';
import { LayoutSplitter } from 'controls/react/layoutSplitter';
import { AntButton } from 'controls/react/ant/antButton';
import { HelpIcon } from 'controls/react/form/formEntryNew';

const b = b_.with('form-builder');
import { i18n } from 'core/localization';

export interface FormBuilderProps {
	store: FormBuilderStore;
}

const ErrorMessages = observer(({ store }: { store: FormBuilderStore }) => {
	if (store.errors.length === 0) return null;

	return (
		<AntAlert
			type="error"
			title={
				<div>
					{store.errors.map((x) => (
						<div key={x.property}>
							{x.property}: {x.error}
						</div>
					))}
				</div>
			}
		/>
	);
});

const FormBuilderToolbar = observer(({ store }: { store: FormBuilderStore }) => {
	if (!store.showAdvancedSwitch) return null;
	return (
		<Toolbar appearance="transparent">
			<AdvancedSwitch store={store} position={ToolbarItemPosition.AT_THE_END} />
		</Toolbar>
	);
});

const AdvancedSwitch = observer(({ store }: { store: FormBuilderStore }) => {
	return (
		<div className={b('advanced')}>
			<AntFlex gap="small">
				<AntSwitch
					size="small"
					checkedChildren={i18n('Hide advanced')}
					unCheckedChildren={i18n('Show advanced')}
					onChange={(value) => store.setAdvanced(value)}
					value={store.showAdvanced}
				/>
				<HelpIcon tooltip={i18n('Show advanced tooltip')} />
			</AntFlex>
		</div>
	);
});

const MainForm = observer(({ store }: { store: FormBuilderStore }) => {
	if (store.options.splitter) {
		return (
			<LayoutSplitter
				percentage={true}
				primaryIndex={0}
				primaryMinSize={20}
				secondaryMinSize={20}
				secondaryInitialSize={60}
				userSettingsCategory={store.splitterUserSettingsCategory}
			>
				{store.visibleForms}
			</LayoutSplitter>
		);
	}
	return <FormLayout type={store.formLayoutType}>{store.visibleForms}</FormLayout>;
});

export const FormBuilder = observer(({ store }: FormBuilderProps) => {
	return (
		<FormBuilderContext.Provider value={store}>
			<Section appearance={'none'} childrenPadding={true} height={'fit'}>
				<FormBuilderToolbar store={store} />
				<ErrorMessages store={store} />
				<MainForm store={store} />
				{store.validator.hasTest && (
					<Toolbar appearance={'transparent'}>
						<AntButton type={'primary'} disabled={!store.validator.valid} onClick={store.validator.test}>
							{i18n('Test configuration')}
						</AntButton>
					</Toolbar>
				)}
			</Section>
		</FormBuilderContext.Provider>
	);
});
